/**
 * Deck iframe chrome (P3) — extracted to a plain-TS module so it is the SINGLE
 * source of truth for the inline pager script. The server CSP allow-lists this
 * exact script by its SHA-256 hash (no `'unsafe-inline'`); a unit test re-hashes
 * `PAGER_JS` and asserts the CSP still lists it, so any edit here that changes the
 * bytes fails the build until the hash is updated. Keep these as literal strings.
 */

/** In-iframe pager: show one slide at a time, ‹ n/total ›, arrow keys / space. */
export const PAGER_JS = `
(function(){
  var slides = document.querySelectorAll('svg[data-marpit-svg]');
  if(!slides.length) slides = document.querySelectorAll('section');
  var i = 0, pg = document.getElementById('deck-pg');
  function show(n){
    i = Math.max(0, Math.min(slides.length-1, n));
    for(var k=0;k<slides.length;k++){ slides[k].style.display = (k===i)?'':'none'; }
    if(pg) pg.textContent = (slides.length? (i+1):0)+' / '+slides.length;
  }
  var prev=document.getElementById('deck-prev'), next=document.getElementById('deck-next');
  if(prev) prev.onclick=function(){show(i-1);};
  if(next) next.onclick=function(){show(i+1);};
  document.addEventListener('keydown', function(e){
    if(e.key==='ArrowRight'||e.key===' '){show(i+1);e.preventDefault();}
    if(e.key==='ArrowLeft'){show(i-1);e.preventDefault();}
  });
  show(0);
})();`;

/** Chrome for the deck iframe: center the current slide + a bottom pager bar. */
export const DECK_CSS = `
  html,body{margin:0;height:100%;background:#0b0f17;}
  body{display:flex;flex-direction:column;}
  .marpit{flex:1;display:flex;align-items:center;justify-content:center;overflow:auto;padding:12px;}
  .marpit>svg,.marpit>section{max-width:100%;max-height:100%;box-shadow:0 2px 14px rgba(0,0,0,.4);}
  #deck-nav{display:flex;align-items:center;justify-content:center;gap:14px;padding:8px;color:#cbd5e1;font:13px system-ui,sans-serif;background:#0b0f17;}
  #deck-nav button{background:#1e293b;color:#e2e8f0;border:1px solid #334155;border-radius:6px;padding:4px 12px;cursor:pointer;}
  #deck-nav button:hover{border-color:#64748b;}`;

export const PAGER_HTML = `<div id="deck-nav"><button id="deck-prev">‹</button><span id="deck-pg"></span><button id="deck-next">›</button></div>`;
